import React, { useEffect, useRef, useState } from 'react';

export default function BlueDotsBackground() {
  const [dots, setDots] = useState([]);
  const dotsRef = useRef([]);
  const animationFrameId = useRef(null);

  useEffect(() => {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const dotCount = 20;
    const colors = ['#0061A8', '#009CDE', '#66D1FF'];

    const newDots = Array.from({ length: dotCount }).map(() => {
      const size = 6 + Math.random() * 8;
      return {
        id: Math.random().toString(36).substr(2, 9),
        size,
        color: colors[Math.floor(Math.random() * colors.length)],
        x: Math.random() * screenWidth,
        y: Math.random() * screenHeight,
        dx: (Math.random() - 0.5) * 0.5, // small movement delta
        dy: (Math.random() - 0.5) * 0.5,
      };
    });

    dotsRef.current = newDots;
    setDots(newDots);
  }, []);

  useEffect(() => {
    const animate = () => {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;

      const updatedDots = dotsRef.current.map((dot) => {
        let newX = dot.x + dot.dx;
        let newY = dot.y + dot.dy;

        // Bounce off edges
        if (newX < 0 || newX > screenWidth) dot.dx *= -1;
        if (newY < 0 || newY > screenHeight) dot.dy *= -1;

        return {
          ...dot,
          x: newX,
          y: newY,
        };
      });

      dotsRef.current = updatedDots;
      setDots(updatedDots);
      animationFrameId.current = requestAnimationFrame(animate);
    };

    animationFrameId.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrameId.current);
  }, []);

  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-black">
      {dots.map((dot) => (
        <div
          key={dot.id}
          className="absolute rounded-full blur-sm opacity-90 transition-transform duration-300"
          style={{
            width: `${dot.size}px`,
            height: `${dot.size}px`,
            backgroundColor: dot.color,
            transform: `translate(${dot.x}px, ${dot.y}px)`,
          }}
        />
      ))}
    </div>
  );
}
